/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import logoFull from '../images/logo-full.png';
import './SignOut.scss';
import { Link, useLocation } from 'react-router-dom';

const SignOut = (): React.JSX.Element => {
  const location = useLocation()

  useEffect(() => {
    const from = location.state?.from

    if (from) localStorage.setItem('referer', from)

    localStorage.removeItem('sessionData')
    localStorage.removeItem('idToken')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
  }, [])

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100">
      <img src={logoFull} className="logo-full d-block mb-5" alt="Feedback Canvas Logo" />
      <p className="text-danger mb-5">
        Você foi desconectado!
      </p>
      <Link to="/" className="btn btn-primary btn-sm">Voltar para o início</Link>
    </div>
  );
}

export default SignOut;
